import {useSelector} from 'react-redux';

import {selectIsMobileLayout} from '../../state/selectors/global';
import Popup from './Popup';
import PopupFullPage from './PopupFullPage';

const PopupMobileFullPage = (props) => {
    const isMobileLayout = useSelector(selectIsMobileLayout);
    const Component = isMobileLayout ? PopupFullPage : Popup;

    return <Component {...props} />;
};

export default PopupMobileFullPage;
